import {
  Box,
  styled,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
  Divider,
} from '@mui/material';
import { useState } from 'react';
import { ListCategories } from './ListCategories';
import { AddCategory } from './AddCategory';
import { EditCategory } from './EditCategory';

const actions = ['Liste', 'Ajouter', 'Modifier'] as const;
type Action = (typeof actions)[number];

export const Categories = () => {
  const [selectedAction, setSelectedAction] = useState<Action>('Liste');

  const handleChangeAction = (event: SelectChangeEvent) => {
    setSelectedAction(event.target.value as Action);
  };

  return (
    <Container>
      <Row justifyContent="space-between">
        <Box component="div">
          <Typography variant="h5">Catégories</Typography>
        </Box>

        <Row>
          <FormControl sx={{ width: '200px' }}>
            <InputLabel id="category-action-label">Action</InputLabel>
            <Select
              labelId="category-action-label"
              id="category-action-select"
              value={selectedAction}
              label="Action"
              onChange={handleChangeAction}
            >
              {actions.map((action) => (
                <MenuItem key={action} value={action}>
                  {action}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Row>
      </Row>

      <Divider />

      {selectedAction === 'Liste' && <ListCategories />}
      {selectedAction === 'Ajouter' && <AddCategory onSuccess={() => setSelectedAction('Liste')} />}
      {selectedAction === 'Modifier' && (
        <EditCategory onSuccess={() => setSelectedAction('Liste')} />
      )}
    </Container>
  );
};

const Container = styled(Box)({
  display: 'flex',
  gap: 16,
  flexDirection: 'column',
  padding: '30px',
});

const Row = styled(Box)({
  display: 'flex',
  gap: 16,
  flexDirection: 'row',
});
